// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3022":"81bbe34e255c4a51","4755":"72da0601f0861c47"}[chunkId] + ".js";
};